import React from 'react'
import './Input.css'

const Input = ({
  label,
  type = 'text',
  placeholder,
  value,
  onChange,
  error,
  required = false,
  className = '',
  name,
  ...props
}) => {
  return (
    <div className={`input-group ${className}`}>
      {label && (
        <label className='input-group__label'>
          {label}
          {required && <span className='input-group__required'>*</span>}
        </label>
      )}
      <input
        type={type}
        name={name}
        className={`input-group__input ${error ? 'input-group__input--error' : ''}`}
        placeholder={placeholder}
        value={value}
        onChange={onChange}
        required={required}
        {...props}
      />
      {error && <span className='input-group__error'>{error}</span>}
    </div>
  )
}

export default Input
